type DropdownItem = {
  label: string;
  link: string;
  onClick?: () => void;
};

type DropdownProps = {
  title: string;
  items: DropdownItem[];
  currentPath?: string;
};

export function Dropdown({ title, items, currentPath }: DropdownProps) {
  return (
    <div className="dropdown">
      <button
        className="dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span>{title}</span>
        <svg
          className="dropdown-chevron"
          aria-hidden="true"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        {items.map((item, index) => (
          <li key={index}>
            <a
              className={`${currentPath === item.link ? 'item_active' : ''} dropdown-item`}
              href={item.link}
              onClick={item.onClick}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
